import Rollbar from 'rollbar';
import { browser } from '$app/environment';
import { env } from '$env/dynamic/public';
import { version } from '$lib/version';

class RollbarService {
  instance: Rollbar | undefined;

  constructor() {
    if (browser && env.PUBLIC_ROLLBAR_TOKEN) {
      this.instance = new Rollbar({
        accessToken: env.PUBLIC_ROLLBAR_TOKEN,
        environment: env.PUBLIC_RUNTIME_ENV || 'development',
        captureUncaught: true,
        captureUnhandledRejections: true,
        payload: {
          code_version: version.hash,
          client: {
            javascript: {
              source_map_enabled: true,
              code_version: version.hash,
              guess_uncaught_frames: true,
            },
          },
        },
      });
    }
  }
}

export const rollbarService = new RollbarService();
